(() => {
  const banner = document.getElementById('oskom-cookie-banner');
  const button = document.getElementById('oskom-cookie-settings');
  const analytics = document.getElementById('oskom-consent-analytics');
  const marketing = document.getElementById('oskom-consent-marketing');
  const status = document.getElementById('oskom-cookie-status');
  if (!banner || !button || !analytics || !marketing) return;

  let privacyApi = null;
  const readChoices = () => {
    if (!privacyApi) return;
    const consent = privacyApi.currentVisitorConsent();
    analytics.checked = consent.analytics === 'yes';
    marketing.checked = consent.marketing === 'yes';
  };
  const show = () => {
    readChoices();
    banner.hidden = false;
  };
  button.addEventListener('click', show);

  const save = (selection) => {
    if (!privacyApi) {
      status.textContent = 'Die Shopify-Datenschutzeinstellungen sind derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.';
      banner.hidden = false;
      return;
    }
    // Only record consent after a click, never on page load.
    privacyApi.setTrackingConsent({
      analytics: selection.analytics,
      marketing: selection.marketing,
      preferences: false
    }, () => {
      banner.hidden = true;
      status.textContent = '';
    });
  };

  banner.querySelector('[data-consent="reject"]').addEventListener('click', () => save({ analytics: false, marketing: false }));
  banner.querySelector('[data-consent="save"]').addEventListener('click', () => save({ analytics: analytics.checked, marketing: marketing.checked }));
  banner.querySelector('[data-consent="accept"]').addEventListener('click', () => save({ analytics: true, marketing: true }));

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    status.textContent = 'Die Cookie-Auswahl wird erst im installierten Shopify-Shop verfügbar.';
    return;
  }
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
    if (error || !window.Shopify.customerPrivacy) {
      status.textContent = 'Die Shopify-Datenschutzeinstellungen konnten nicht geladen werden.';
      return;
    }
    privacyApi = window.Shopify.customerPrivacy;
    const consent = privacyApi.currentVisitorConsent();
    readChoices();
    // Show the banner if no decision is recorded. Shopify's region settings
    // must also require consent in the EEA, so Shopify-managed pixels wait.
    if (!consent.analytics || !consent.marketing) banner.hidden = false;
    document.addEventListener('visitorConsentCollected', () => readChoices());
  });
})();
